<template>
  <div id="extend" class="word-break-keep-all">
    <section id="hero">
      <div class="container">
        <p>전력분석보고서</p>
        <h1 class="title">전력 분석 자동화 보고서로 <br class="hidden-sm">영업이 쉬워집니다.</h1>
      </div>
    </section>
    <section id="search">
      <div class="container">
        <div v-if="!user.id" style="position: absolute; width: 100%; height: 100%; z-index: 5;" @click="showLoginModal"></div>
        <div class="input-wrap">
          <p>필수 입력 정보</p>
          <input class="hz-input-default" type="text" v-model="powerPlanner.pp_id" placeholder="한전 파워플래너 아이디">
          <input class="hz-input-default" type="text" v-model="powerPlanner.pp_pw" placeholder="한전 파워플래너 비밀번호">
          <input class="hz-input-default customer-name" type="text" v-model="powerPlanner.name" placeholder="프로젝트명(고객명)">
          <button type="button" class="btn-search" @click="createReportPre">보고서제작</button>
        </div>
      </div>
    </section>
    <section id="list" v-if="user.id">
      <div class="container">
        <div class="search-wrap" v-if="user.auth_level === '90'">
          <div class="row">
            <div class="col-sm-4">
              <p class="title">보고서 목록</p>
            </div>
            <div class="col-sm-8 text-right">
              <input type="text" class="hz-input-default hz-input-md" maxlength="100" placeholder="프로젝트명을 입력해주세요." v-model="searchText" @keypress.prevent.enter="searchProject">
              <button type="button" class="hz-btn-primary hz-btn-md" @click="searchProject">검색하기</button>
            </div>
          </div>
        </div>
        <kendo-grid
                    class="epa-grid"
                    ref="grid"
                    :columns="tableFields"
                    :options="tableOptions"
                    :auth="true"
                    :dataUrl="dataUrl"
                    :message="'저장된 보고서가 없습니다.'" :dblClickRow="viewDetail"></kendo-grid>
      </div>
    </section>
    <!-- 보고서 생성 알림창 -->
    <modal ref="createModal" :id="createModal.id" :type="createModal.type"
           :title="createModal.title" :size="createModal.size" :fields="createModal.fields"
           @submit="createReport"></modal>
    <!-- 보고서 삭제 알림창 -->
    <modal ref="removeModal" :id="removeModal.id" :type="removeModal.type" :title="removeModal.title"
           :size="removeModal.size" :fields="removeModal.fields" @submit="removeReport"></modal>
    <!-- generic 알림창 -->
    <modal ref="genericModal" :id="genericModal.id" :type="genericModal.type" :title="genericModal.title"
           :size="genericModal.size" :fields="genericModal.fields" @submit="onCloseGenericModal"></modal>
  </div>
</template>

<script>
  import api from '@/api/index'
  import KendoGrid from 'common/components/KendoGrid'
  import Modal from 'common/components/Modal'
  import eventHub from '@/shared/EventHub'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'epa',
    components: { KendoGrid, Modal },
    data: function () {
      return {
        powerPlanner: {
          pp_id: '',
          pp_pw: '',
          name: ''
        },
        searchText: '',
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/electric-power-analysis/',
        companyAllCheck: false,
        selectReportId: '',
        tableFields: [
          {
            field: 'category',
            title: '구분',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false,
            template: function () {
              return 'DR'
            }
          },
          {
            field: 'name',
            title: '프로젝트명(고객명)',
            type: 'string',
            width: '250px',
            attributes: { class: 'show-tooltip' },
            sortable: false,
            filterable: {multi: true, search: true}
          },
          {
            field: 'updated',
            title: '저장일',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'username',
            title: '담당자',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: {multi: true, search: true}
          },
          {
            field: 'pp_status',
            title: '상태',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              switch (dataItem['pp_status']) {
                case 'pending':
                  return '생성중'
                case 'working':
                  return '수집중'
                case 'failure':
                  return '로그인실패'
                case 'error':
                  return '에러'
                case 'canceled':
                  return '취소'
                case 'done':
                  return `<img class="glyphicon" src="/s/assets/img/biz/report/epa/epa_download.png" style="width: 14px; height: auto; cursor: pointer;" rpid='${dataItem['id']}' type='epa' status="${dataItem['pp_status']}">`
                default:
                  return '실패'
              }
            }
          },
          {
            field: 'delete',
            title: '삭제',
            type: 'string',
            width: '80px',
            sortable: false,
            filterable: false,
            template: function (dataItem) {
              return `<img class="k-grid-remove" src="/s/assets/img/biz/report/epa/epa_delete.png" style="width: 24px; height: auto; cursor: pointer;" rpid="${dataItem['id']}" regby="${dataItem['reg_by']}" title="${dataItem['name']}" status="${dataItem['pp_status']}">`
            }
          }
        ],
        tableOptions: {
          parameter: [
            { name: 'all_check', value: 'N' },
            { name: 'project_name', value: '' }
          ],
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 20,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        },
        createModal: {
          id: 'createModal',
          type: 'confirm',
          title: '보고서 생성',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['전력분석보고서를 생성하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        removeModal: {
          id: 'removeModal',
          type: 'confirm',
          title: '보고서 삭제',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        },
        genericModal: {
          id: 'genericModal',
          type: 'alert',
          title: '',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user',
        isPaidMember: 'isPaidMember'
      })
    },
    watch: {
      'user': {
        handler (val) {
          // 로그인한 유저일 경우, 해당 페이지에 접근 권한을 체크한다.
          if (typeof val.id !== 'undefined') {
            this.$store.dispatch('checkAccessMenu')
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      showLoginModal () {
        // Main.vue로 이벤트 전달
        eventHub.$emit('showLoginModal')
      },
      showGenericModal (title, message) {
        this.genericModal.title = title
        this.genericModal.fields[0].message = [message]
        this.$nextTick(() => {
          this.$refs.genericModal.show()
        })
      },
      onCloseGenericModal () {
        this.genericModal = {
          ...this.genericModal,
          title: '',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      },
      createReportPre () {
        /* eslint-disable camelcase */
        const { pp_id, pp_pw, name } = { ...this.powerPlanner }
        if (pp_id.length < 4 || pp_pw.length < 0 || name.length < 2) {
          this.showGenericModal('입력 오류', '입력값을 다시한번 확인 해 주세요.')
          return false
        }
        this.$refs.createModal.show()
      },
      createReport () {
        api.saveEpaReport(this.powerPlanner, response => {
          if (typeof response.id === 'number') {
            this.powerPlanner = {
              pp_id: '',
              pp_pw: '',
              name: ''
            }
            this.$refs.grid.refresh()
            this.showGenericModal('', '보고서 생성 요청을 완료하였습니다.')
          } else {
            this.showGenericModal('에러 (' + response.response.status + ')', response.response.data.message)
          }
        })
      },
      viewDetail (id, data, preview = false) {
        if (!this.isPaidMember) {
          eventHub.$emit('showChargeModal')
          return false
        }
        if (data['pp_status'] !== 'done') {
          this.showToastMessage('데이터 수집이 완료되지 않았습니다.')
          return false
        }
        if (preview) {
          this.$router.push({name: 'epaLoad', params: {id: id, preview: true}})
        } else {
          this.$router.push({name: 'epaLoad', params: {id: id}})
        }
      },
      setDownloadEvent () {
        $(document).on('click', '.kendo-grid tbody tr .glyphicon', (e) => {
          const id = e.target.getAttribute('rpid')
          const pp_status = e.target.getAttribute('status')
          this.viewDetail(id, {
            id,
            pp_status
          }, true)
        })
      },
      setRemoveEvent () {
        $(document).on('click', '.kendo-grid tbody tr .k-grid-remove', (e) => {
          const target = e.target
          const registerUser = parseInt(target.getAttribute('regby'))
          const currentUser = parseInt(this.user.id)

          // 로그인한 사용자가 보고서 작성자와 동일한지 확인
          if (registerUser === currentUser) {
            this.selectReportId = target.getAttribute('rpid')
            this.removeModal.fields[0].message = [target.title + ' 보고서를 삭제하시겠습니까?']
            this.$refs.removeModal.show()
          } else {
            alert('본인이 작성한 보고서가 아닙니다.')
          }
        })
      },
      removeReport () {
        api.removeEpaReport(this.selectReportId, response => {
          if (response.error) {
            this.showToastMessage('보고서 삭제실패')
          } else {
            this.showToastMessage('보고서 삭제완료')
            this.$refs.grid.refresh()
          }
        })
      },
      searchProject () {
        const text = this.searchText

        // 보고서 프로젝트명 검색 클릭 시 API Parameter를 설정해준다.
        this.tableOptions.parameter[1].value = text
        this.$refs.grid.refresh()
      }
    },
    created () {
      const token = localStorage.getItem('_t')

      // 토큰이 있을 경우, 토큰의 유호성을 검사한다.
      if (token) {
        this.$store.dispatch('inspectToken', token).then(() => {
          // 유효한 토큰 일 경우 보고서 이동, 삭제 이벤트를 등록해준다.
          this.$nextTick(() => {
            this.setDownloadEvent()
            this.setRemoveEvent()
          })
        })
      }
    },
    mounted () {
      // 로그인한 유저 일 경우, 해당 페이지에 접근권한이 있는지 확인한다.
      if (typeof this.user.id !== 'undefined') {
        this.$store.dispatch('checkAccessMenu')
      }
    },
    beforeDestroy () {
      // 엘리먼트 및 이벤트 초기화
      kendo.destroy(document.body)
      $(document).off('click', '.kendo-grid tbody tr .glyphicon')
      $(document).off('click', '.kendo-grid tbody tr .k-grid-remove')
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/pages/index_report';
  @import '~@/assets/css/components/tab';

  #hero {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url("../../assets/img/epa/epa_hero_desktop.jpg");

    .container {
      padding: 119px 0 119px 96px;
    }

    h1 {
      color: $hzc-white;
    }

    p {
      margin: 0 0 24px;
      color: $orange;
    }

    @media (max-width: 992px) {
      background-image: url("../../assets/img/epa/epa_hero_mobile.jpg");
      text-align: center;

      .container {
        padding: 84px 16px 256px;
      }
    }
  }

  #search {
    .input-wrap {
      max-width: 1180px;
      margin: auto;

      p {
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: bold;
      }

      input[type="text"],
      input[type="password"] {
        width: 256px;
        height: 48px;
        padding: 13px 33px 13px 16px;

        &[type="password"] {
          margin: 0 8px;
        }

        &.customer-name {
          width: calc(100% - 712px);
        }
      }

      @media (max-width: 992px) {
        input[type="text"],
        input[type="password"] {
          width: 100%;
          margin: 0;

          &[type="password"] {
            margin: 8px 0;
          }

          &.customer-name {
            width: 100%;
          }
        }

        .btn-search {
          width: 100%;
          margin-top: 8px;
        }
      }
    }
  }

  #list {
    padding: 60px 16px;

    .search-wrap {
      .title {
        font-size: 16px;
        font-weight: bold;
      }
    }

    @media (max-width: 752px) {
      padding: 32px 16px;

      .search-wrap {
        > div {
          padding: 0;
        }

        .title {
          margin-bottom: 24px;
          text-align: center;
        }
      }

      .text-right {
        input {
          height: 32px;
        }

        button {
          position: absolute;
          right: 0;
          width: 110px;
          height: 32px;
        }

        padding: 0 118px 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/epa/Epa.vue